import React from 'react';
import './FooterContainer.css'; 

const year = new Date().getFullYear();

const FooterContainer = () => {
    return (
        <footer>
            <div className="footer-div">
                &copy; {year} <a href='https://vvsoluciones.tech/'>VV Soluciones Tecnológicas</a>. Todos los derechos reservados.
            </div>
        </footer>
    );
}

export default FooterContainer;
